import { Component, OnInit } from '@angular/core';
import { ApiService } from 'src/app/shared/_service/api.service';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from 'src/app/auth/_service/auth.service';

@Component({
	selector: 'app-nuovo-utente',
	templateUrl: './nuovo-utente.component.html',
})
export class NuovoUtenteComponent implements OnInit {
	constructor(
		private api: ApiService,
		private route: ActivatedRoute,
		private router: Router,
	) {}

	clienti = [];
	jsonIn: any = {
		ruolo: null,
		idCliente: null,
		abilitaSconti: false,
		idAgente: null,
		limiteScontoPercentuale: 0,
		idCompany: null,
	};
	mercati = [];
	listaCompany = [];

	dropdownSettings = {
		singleSelection: false,
		idField: 'id',
		textField: 'codiceMercato',
		selectAllText: 'Seleziona tutti',
		unSelectAllText: 'Deseleziona tutti',
		itemsShowLimit: 5,
		allowSearchFilter: false,
	};

	ngOnInit() {
		this.route.params.subscribe((params) => {
			if (params.id !== '0') {
				this.api.getUtente({ id: params.id / 1 }).subscribe((user) => {
					this.jsonIn = {
						...user,
						idCliente: user.cliente ? user.cliente.id : null,
						idMercati: user.mercati || [],
						idCompany: user.company.id,
					};
				});
			}
		});
		this.api.getClienti().subscribe((res) => (this.clienti = res));
		this.api.getMercati().subscribe((res) => {
			this.mercati = res;
			this.mercati.sort((a, b) => a.codiceMercato.localeCompare(b.codiceMercato)); // Ordering Alphabetically;
		});
		this.api.getListaCompany().subscribe(
			(res) => (this.listaCompany = res),
			() => alert('Erorre nel recupero delle company'),
		);
	}

	aggiungi() {
		if (this.jsonIn.idMercati) {
			this.jsonIn.idMercati = this.jsonIn.idMercati.map((ids) => ids.id);
		}

		if (this.jsonIn.id) {
			delete this.jsonIn.password;
		}

		this.api.saveUtente(this.jsonIn).subscribe(
			(res) => {
				if (res) {
					this.router.navigate(['/configurazione-utente']);
				}
			},
			() => alert("Errore nella creazione dell'utente"),
		);
	}
}
